import { UserDeviceModel } from "./UserDevice.model";

export class UserDevice extends UserDeviceModel {
    // Add custom methods here
}
